export default __webpack_public_path__ + "static/media/NotoSans-Medium.265566c7.otf";